<template>
  <el-container class="list" style="display:block;">
		<div><el-button type="primary" @click="drawer = true" style="background: #3A8EE6;margin-left: 400px;margin-top: 30px;">添加员工</el-button></div>
		<el-table
			class="user-table"
			:data="lists"
			style="width: 100%">
			<el-table-column
			  label="姓名"
			  width="240">
			  <template slot-scope="scope">
				<div slot="reference" class="name-wrapper">
					{{ scope.row.user_name }}
				</div>
			  </template>
			</el-table-column>
			<el-table-column
			  label="职位"
			  width="240">
			  <template slot-scope="scope">
				<div slot="reference" class="name-wrapper">
					{{ scope.row.role_name }}
				</div>
			  </template>
			</el-table-column>
			<el-table-column
			  label="账户"
			  width="240">
			  <template slot-scope="scope">
				<div slot="reference" class="name-wrapper">
					{{ scope.row.name }}
				</div>
			  </template>
			</el-table-column>
			<el-table-column label="操作" width="240">
			  <template slot-scope="scope">
				<el-button
				  size="mini"
				  @click="change(scope.row.id)">修改职位</el-button>
				<el-button
				  size="mini"
				  type="danger"
				  @click="del(scope.row.id)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
		<!-- <div class="role-r">
			<span>选择职位:</span>
			<select v-model="value">
				<option value="check">审核专员</option>
				<option value="entry">数据专员</option>
			</select>
		</div> -->
		<el-drawer
		  title="添加员工"
		  :visible.sync="drawer"
		  :direction="direction">
		 <div class="add-new">
		 	<span>员工姓名:</span>
		 	<el-input
				style="width: 400px;"
		 		class="add-new-input"
		 		placeholder="姓名"
		 		prefix-icon="el-icon-phone"
		 		v-model="newUserName">
		 	</el-input>
		 </div>
		  <div class="add-new">
		  	<span>员工手机:</span>
		  	<el-input
				style="width: 400px;"
		  		class="add-new-input"
		  		placeholder="手机号"
		  		prefix-icon="el-icon-phone"
		  		v-model="newPhone">
		  	</el-input>
		  </div>
		  <div class="add-new">
		  	<span>选择职位:</span>
		  	<el-select class="add-new-input" v-model="newPostion" placeholder="请选择职位">
				<el-option
				  v-for="item in options"
				  :key="item.value"
				  :label="item.label"
				  :value="item.value">
				</el-option>
			</el-select>
		  </div>
		  <div class="h-confim" style="margin-top: 20px" @click="addUser()">确认</div>
		</el-drawer>
	</el-container>

</template>

<script>

  export default {
    data() {
      return {
        lists: [],
		id:0,
		drawer:false,
		direction:'ttb',
		newPhone:'',
		newPostion:'',
		newUserName:'',
        postion: 'entry',
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl,
		options: [{
          value: 'admin',
          label: '数据负责人'
        }, {
          value: 'entry',
          label: '数据专员'
        }, {
          value: 'ui',
          label: 'ui设计师'
        }, {
          value: 'web',
          label: '前端'
        }, {
          value: 'webz',
          label: '前端助理'
        }, {
          value: 'fenxi',
          label: '语言分析'
        }, {
          value: 'yuzhou',
          label: '【语句宇宙】部门专员'
        }, {
          value: 'adminj',
          label: '【监测宇宙】部门专员'
        }, {
          value: 'shijian',
          label: '【时间宇宙】部门专员'
        }, {
          value: 'close',
          label: '关闭权限'
        }]
      }

    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
	 //  var cip = returnCitySN["cip"];
// 	   if(this.$store.getters.getRole != 'admins'){
// 	   		   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 	   			   this.$router.push({ path: '/' })
// 	   		   }
// 	   }
       this.loadData();
    },
	methods:{
			loadData(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					url:'http://y31p.yoooooo.com/index.php/index/data/userList',

				})
				.then(res=>{
					this.lists = res.data;

				})
				.catch(err=>{

				});
			},
			handleEdit(index, row) {
				console.log(index, row);
			  },
			  handleDelete(index, row) {
				console.log(index, row);
			  },
			  getCouponSelected(){
				  alert(this.postion)
			  },
			  change(id) {
				let html = '<div class="role-r">'+
						   '<span>选择职位:</span>'+
						   '<select v-model="postion" id="postion">'+
						   '<option value="admin">数据负责人</option>'+
						   '<option value="entry">数据专员</option>'+
               '<option value="ui">ui设计师</option>'+
               '<option value="web">前端</option>'+
               '<option value="webz">前端助理</option>'+
               '<option value="fenxi">语言分析</option>'+
               '<option value="yuzhou">【语句宇宙】部门专员</option>'+
               '<option value="adminj">【监测宇宙】部门专员</option>'+
               '<option value="shijian">【时间宇宙】部门专员</option>'+
               '<option value="close">关闭权限</option>'+
						   '</select>'+
						   '</div>';
				this.$alert(html, {
				  confirmButtonText:'修改职位',
				  dangerouslyUseHTMLString: true,

				}).then(() => {
					var obj = document.getElementById('postion');
					var index = obj.selectedIndex;

					const axiosInstance = this.$axios.create({
						headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
						withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
					});
					axiosInstance({
						method:'post',
						url:'http://y31p.yoooooo.com/index.php/index/data/changeUser',
						params:{
							id:id,
							token:this.token,
							userId:this.userId,
							postion:obj.options[index].value
						}
					})
					.then(res=>{

						if(res.data.code == 200){
							this.$message({
								type: 'success',
								message: '修改成功'
							});
							this.loadData();
						}else{
							this.$message({
								type: 'error',
								message: '请登录'
							});
						}
					})
					.catch(err=>{

					});
				});
			  },
			  addUser(){
          if(this.newUserName == ''){
              this.$message({
              	type: 'error',
              	message: '请输入姓名'
              });
              return false
          }
          if(this.newPhone == ''){
              this.$message({
              	type: 'error',
              	message: '请输入手机号'
              });
              return false
          }
          if(this.newPostion == ''){
              this.$message({
              	type: 'error',
              	message: '请选择职位'
              });
              return false
          }
				  const axiosInstance = this.$axios.create({
				  	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				  	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				  });
				  axiosInstance({
				  	method:'post',
				  	params:{
				  		newPhone:this.newPhone,
						role:this.newPostion,
						userName:this.newUserName,
				  		token:this.token,
				  		userId:this.userId,
				  	},
				  	url:'http://y31p.yoooooo.com/index.php/index/data/addUser'
				  })
				  .then(res=>{
				  	if(res.data.code == 200){
				  	 	this.$message({
				  	 		type: 'success',
				  	 		message: '添加成功'
				  	 	});
				  	  this.drawer = false;
					  this.loadData();
				  	 }else{
				  	 	this.$message({
				  	 		type: 'error',
				  	 		message: res.data.msg
				  	 	});
				  	 }
				  })
				  .catch(err=>{

				  });
			  },
			  del(id) {
				this.$confirm('此操作将永久删除该员工, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					const axiosInstance = this.$axios.create({
						headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
						withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
					});
					axiosInstance({
						method:'get',
						url:'http://y31p.yoooooo.com/index.php/index/data/delUser',
						params:{
							id:id,
							token:this.token,
							userId:this.userId
						}
					})
					.then(res=>{
						if(res.data.code == 200){
							this.$message({
								type: 'success',
								message: '删除成功'
							});

							this.loadData();
						}else{
							this.$message({
								type: 'error',
								message: '请登录'
							});
						}
					})
					.catch(err=>{

					});

				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '已取消删除'
				  });
				});
			  }

	}


  }
</script>

<style>
	.user-table{
		margin-left: 20%;
		margin-top: 50px;
	}
	.role-r select{
		width: 200px;
		height: 30px;
		margin-left: 20px;
	}
	.add-new{
		margin-left: 30px;
	}
	.add-new-input{
		width: 400px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/user.vue